// Bus de Smack: eventos de navegador, mismo patrón (y mismo motivo) que
// carritosBus.js — UserContext es un array posicional con decenas de consumidores
// y meterle contadores obliga a tocarlo.
//
// 1) 'wa:smack-cambiado' — lo emite quien escribe (enviar mensaje, marcar leído,
//    marcar/resolver un pendiente) para que el poller del sidebar refresque los
//    contadores SIN esperar 60 s.
// 2) 'wa:smack-unread' — lo emite el ÚNICO poller (SidebarBest, montado siempre)
//    con el total en `detail`, y lo escucha quien pinte un badge sin permitirse
//    otro poll propio (MobileBottomNav). Un solo origen de peticiones.
// 3) 'wa:smack-pendientes' — mismo patrón que (2) pero para el backlog de
//    pendientes sin resolver (distinto de los no-leídos): un mensaje puede
//    estar leído y seguir sin resolverse.
const EVENTO_CAMBIO = 'wa:smack-cambiado';
const EVENTO_UNREAD = 'wa:smack-unread';
const EVENTO_PENDIENTES = 'wa:smack-pendientes';

export function avisarSmackCambiado() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(EVENTO_CAMBIO));
}

/** Devuelve la función para dejar de escuchar (para el cleanup del efecto). */
export function alCambiarSmack(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENTO_CAMBIO, handler);
  return () => window.removeEventListener(EVENTO_CAMBIO, handler);
}

export function publicarSmackUnread(total) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTO_UNREAD, { detail: { total: Number(total) || 0 } }));
}

/** Devuelve la función para dejar de escuchar (para el cleanup del efecto). */
export function alCambiarSmackUnread(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENTO_UNREAD, handler);
  return () => window.removeEventListener(EVENTO_UNREAD, handler);
}

export function publicarSmackPendientes(total) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTO_PENDIENTES, { detail: { total: Number(total) || 0 } }));
}

/** Devuelve la función para dejar de escuchar (para el cleanup del efecto). */
export function alCambiarSmackPendientes(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENTO_PENDIENTES, handler);
  return () => window.removeEventListener(EVENTO_PENDIENTES, handler);
}
